import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../../../../api";
import { AxiosError } from "axios";

export function useAttendanceLocalDepartmentQueueServiceTimeComplementDelete() {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    return useMutation<
        void,
        AxiosError<{ detail: string }>,
        number
    >({
        mutationKey: ["attendance-local", "department", "queue", "service-time-complement", "delete"],
        mutationFn: async (id: number) => {
            await apisiseci.delete(`/cms/tempo_servico_complementar_fila/${id}/`, {
                headers: { Authorization: `Bearer ${token}` }
            });
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['attendance-local', 'department', 'queue', 'service-time-complement', 'list']
            });
            toast.success("Tempo de serviço complementar removido com sucesso!");
        },
        onError: (error) => {
            toast.error(
                error?.response?.data?.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });
}
